import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import showErrMessage from "@components/ShowErrMessage";
import showMessage from "@components/ShowMessage";
import "@assets/styles/public.scss";
import { authAction } from "@redux/modules";

const TwoFactor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginSettings = useSelector((store) => store.auth.loginSettings);
  const authState = useSelector((store) => store.auth);
  const [verificationCode, setVerificationCode] = useState("");
  const [disabledButton, setDisabledButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120); // 2 dakika

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Authentication durumu değiştiğinde yönlendirme
  useEffect(() => {
    if (authState.isAuthenticated && authState.authUser) {
      const redirectTimer = setTimeout(() => {
        navigate("/home", { replace: true });
      }, 100);
      return () => clearTimeout(redirectTimer);
    }
  }, [authState.isAuthenticated, authState.authUser, navigate]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setDisabledButton(true);
    setLoading(true);
    const username = localStorage.getItem("username");
    const password = sessionStorage.getItem("password");
    try {
      const response = await dispatch(
        authAction.twoFactorConfirm(verificationCode, username, password)
      );
      if (response.isHttpSuccess) {
        localStorage.removeItem("username");
        sessionStorage.removeItem("password");
        showMessage("İki faktörlü doğrulama başarılı.");
        // Yönlendirme artık useEffect ile yapılacak
      }
    } catch (error) {
      showErrMessage(error.message);
    } finally {
      setDisabledButton(false);
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    try {
      //await dispatch(authAction.resendTwoFactorCode());
      setTimer(120); // Süreyi sıfırla
      showMessage("Doğrulama kodu tekrar gönderildi.");
    } catch (error) {
      showErrMessage(error.message);
    }
  };

  return (
    <section>
      <div className="container-fluid">
        <div className="row align-items-stretch">
          <div className="col-lg-6 bg-gray-lightest">
            <div className="row min-vh-100 align-items-center justify-content-center">
              <div className="col-xxl-7 col-lg-10 col-md-8 col-10 py-md-8 py-5">
                <div className="text-center mb-6">
                  {loginSettings?.logo && (
                    <img
                      src={loginSettings?.logo}
                      alt="logo"
                      className="auth-logo"
                    />
                  )}
                </div>
                <h5 className="lh-base text-center fw-normal mb-4">
                  İki Faktörlü Doğrulama
                </h5>
                <p className="text-center mb-4">
                  Telefonunuza gönderilen doğrulama kodunu giriniz.
                </p>
                <p className="text-center mb-4">
                  Kalan Süre:{" "}
                  <span className="fw-bold">{formatTime(timer)}</span>
                  {timer === 0 && (
                    <button
                      type="button"
                      onClick={handleResendCode}
                      className="btn btn-outline-secondary py-2 px-sm-4 px-3 rounded-3 w-100"
                    >
                      Kodu Tekrar Gönder
                    </button>
                  )}
                </p>

                <form onSubmit={handleVerify}>
                  <div className="form-floating shadow-lg mb-4 rounded-3">
                    <input
                      type="text"
                      className="form-control border-0 rounded-3 px-4"
                      placeholder="Doğrulama Kodu"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                      maxLength={6}
                    />
                    <label htmlFor="verificationCode" className="px-4">
                      <i className="fas fa-shield-alt me-3"></i>Doğrulama Kodu
                    </label>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-blue py-sm-3 py-2 px-sm-4 px-3 rounded-3 w-100 mb-4"
                    disabled={disabledButton || loading || !verificationCode}
                  >
                    {loading && (
                      <span className="spinner-border spinner-border-sm me-3"></span>
                    )}
                    Doğrula <i className="fas fa-arrow-right ms-3"></i>
                  </button>
                </form>

                <div className="text-center mt-md-8 mt-5">
                  <p>
                    <a
                      href="tel:08503351358"
                      className="text-gray-darkest text-decoration-none"
                    >
                      <i className="fas fa-phone-alt me-3"></i>0850 335 1358
                    </a>
                  </p>
                  <p className="fw-lighter opacity-50">
                    Copyright © 2024 Jarvis. Tüm Hakları Saklıdır.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-lg-block d-none bg-blue">
            <div className="row min-vh-100 align-items-center justify-content-center">
              <div className="col-xxl-8 col-lg-10 py-md-8 py-5">
                <div className="swiper sliderLogin">
                  <div className="swiper-wrapper mb-md-8 mb-5">
                    {loginSettings?.banner && (
                      <div className="bg-none">
                        <div className="text-white">
                          <img
                            src={loginSettings?.banner}
                            alt=""
                            className="login-banner mb-5"
                          />
                          {loginSettings?.loginPageTitle && (
                            <h2 className="text-white mb-3">
                              {loginSettings?.loginPageTitle}
                            </h2>
                          )}
                          {loginSettings?.loginPageDescription && (
                            <p className="mb-4">
                              {loginSettings?.loginPageDescription}
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="swiper-pagination swiper-pagination-white"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoFactor;
